import { useEffect, useState } from "react";
import api from "../api";
import ScheduledEmails from "../components/ScheduledEmails";

const KIND_IT = {
  risposta: "Risposta", email: "Email", inoltro: "Inoltro", whatsapp: "WhatsApp", campagna: "Campagna",
  "f24-avviso": "Avviso F24", "f24-sollecito": "Sollecito F24", "sollecito-f24": "SMS sollecito F24",
  "promemoria-appuntamento": "Promemoria appuntamento", "sms-manuale": "SMS manuale", sms: "SMS",
  "richiesta-recensione": "Richiesta recensione Google", programmata: "Email programmata",
};
function kindLabel(k) {
  if (!k) return "Email";
  if (k.startsWith("funnel-lez-")) return `Funnel · Lezione ${k.replace("funnel-lez-", "")}`;
  return KIND_IT[k] || k;
}
function toStr(to) { return Array.isArray(to) ? to.join(", ") : (to || ""); }

export default function SentEmails() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [channel, setChannel] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/emails/sent?limit=1000").then((r) => setList(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = list.filter((m) => {
    if (channel && (m.channel || "email") !== channel) return false;
    if (!q) return true;
    const hay = (toStr(m.to) + " " + (m.subject || "") + " " + kindLabel(m.kind)).toLowerCase();
    return hay.includes(q.toLowerCase());
  });

  return (
    <div>
      <h1 className="page-title">Inviate</h1>
      <p className="page-sub">Tutte le email, gli SMS e i messaggi WhatsApp inviati dallo Studio</p>

      <ScheduledEmails />

      <div className="toolbar" style={{ gap: 10, flexWrap: "wrap" }}>
        <input placeholder="Cerca per destinatario, oggetto…" value={q} onChange={(e) => setQ(e.target.value)} style={{ minWidth: 280 }} data-testid="sent-search" />
        <select value={channel} onChange={(e) => setChannel(e.target.value)} data-testid="sent-channel">
          <option value="">Tutti i canali</option>
          <option value="email">Email</option>
          <option value="sms">SMS</option>
          <option value="whatsapp">WhatsApp</option>
        </select>
        <div className="spacer" />
        <span className="muted" data-testid="sent-count">{filtered.length} inviati</span>
      </div>

      <div className="panel">
        {loading ? <p className="empty">Caricamento…</p> : filtered.length === 0 ? (
          <p className="empty">Nessun invio trovato.</p>
        ) : (
          <table data-testid="sent-table">
            <thead><tr><th>Data</th><th>Canale</th><th>Destinatario</th><th>Oggetto</th><th>Tipo</th></tr></thead>
            <tbody>
              {filtered.map((m) => (
                <tr key={m.id} data-testid={`sent-row-${m.id}`}>
                  <td className="muted" style={{ whiteSpace: "nowrap" }}>{m.sent_at ? new Date(m.sent_at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—"}</td>
                  <td>{{ whatsapp: "WhatsApp", sms: "📱 SMS" }[m.channel || "email"] || "Email"}</td>
                  <td>{toStr(m.to)}</td>
                  <td>{m.subject || <span className="muted">(senza oggetto)</span>}
                    {m.track_token && <span className="pill" style={{ marginLeft: 8, background: "#0e7490" }}>tracciata</span>}
                    {m.esito === "non consegnata" && <span className="pill" style={{ marginLeft: 8, background: "#b91c1c" }} title={m.errore || ""} data-testid={`sent-bounce-${m.id}`}>📭 NON consegnata</span>}
                    {m.esito === "fallita" && <span className="pill" style={{ marginLeft: 8, background: "#b91c1c" }} title={m.errore || ""} data-testid={`sent-failed-${m.id}`}>⚠️ invio fallito</span>}
                  </td>
                  <td className="muted">{kindLabel(m.kind)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
